import React from 'react';
import { cn } from '@/utils/cn';
import { cartLabels } from '@/data/content';

type AllergenStyle = {
    className: string;
    emoji: string;
};

const allergenMap: Record<string, AllergenStyle> = {
    Gluten: { className: 'bg-amber-100 text-amber-600', emoji: '🌾' },
    'Produits laitiers': { className: 'bg-sky-100 text-sky-700', emoji: '🥛' },
    Lait: { className: 'bg-sky-100 text-sky-700', emoji: '🧀' },
    Arachides: { className: 'bg-orange-100 text-orange-700', emoji: '🥜' },
    'Noix de cajou': { className: 'bg-fuchsia-100 text-fuchsia-700', emoji: '🌰' },
    'Fruits à coque': { className: 'bg-fuchsia-100 text-fuchsia-700', emoji: '🌰' },
    Œufs: { className: 'bg-yellow-200 text-yellow-600', emoji: '🥚' },
    Soja: { className: 'bg-green-100 text-green-700', emoji: '🌱' },
    Poisson: { className: 'bg-cyan-100 text-cyan-700', emoji: '🐟' },
    Crustacés: { className: 'bg-rose-100 text-rose-600', emoji: '🦐' },
};

const defaultStyle: AllergenStyle = { className: 'bg-slate-100 text-slate-600', emoji: '⚠️' };

interface AllergenBadgesProps {
    allergens?: string[];
}

const AllergenBadges: React.FC<AllergenBadgesProps> = ({ allergens = [] }) => {
    if (!allergens || allergens.length === 0) {
        return null;
    }

    return (
        <div className="allergens-wrapper">
            <span className="allergens-title">{cartLabels.allergen_prefix}</span>
            <div className="allergens-group">
                {allergens.map((allergen, idx) => {
                    const key = Object.keys(allergenMap).find((k) => k.toLowerCase() === allergen.toLowerCase());
                    const style = key ? allergenMap[key] : defaultStyle;

                    return (
                        <span
                            key={idx}
                            className={cn('rich-allergen-badge', style.className)}
                            title={`${cartLabels.contains_prefix}${allergen}`}
                        >
                            <span aria-hidden="true">{style.emoji}</span>
                            {allergen}
                        </span>
                    );
                })}
            </div>
        </div>
    );
};

export default AllergenBadges;
